// extracted by mini-css-extract-plugin
export var logo = "_ai-2";
export var logoWrapper = "_ai-1";
export var strip = "_ai-0";